// Completion toast, raised when a session finishes analyzing while the user is
// NOT watching its loading screen (e.g. they navigated away). Clicking "Ouvrir"
// jumps to the review; the toast also auto-dismisses after a few seconds via a
// visible shrinking countdown bar. Tinted with the session noyau when set.
import { accentStyle } from '@/lib/bulk-add/accent';
import { useBulkAdd } from '@/lib/bulk-add/bulk-session';
import { useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';

/** Auto-dismiss duration for the completion toast, in ms. */
const TOAST_DURATION_MS = 6000;

/** Floating completion toast for off-screen analysis completion. */
export function BulkToast() {
  const bulk = useBulkAdd();
  const navigate = useNavigate();
  const toast = bulk.toast;

  // Auto-dismiss after the countdown; reset the timer whenever the toast changes.
  useEffect(() => {
    if (!toast) return;
    const handle = setTimeout(() => bulk.dismissToast(), TOAST_DURATION_MS);
    return () => clearTimeout(handle);
  }, [toast, bulk]);

  if (!toast) return null;

  function handleOpen() {
    if (!toast) return;
    bulk.openSession(toast.sessionId);
    bulk.dismissToast();
    void navigate({ to: '/words/bulk-add' });
  }

  return (
    <div className="bulk-toast" style={accentStyle(toast.noyau)} aria-live="polite">
      <div className="bulk-toast__body">
        <span className="bulk-toast__title">Revue d'ajout disponible</span>
        <span className="bulk-toast__name">{toast.name}</span>
      </div>
      <button type="button" className="bulk-toast__open" onClick={handleOpen}>
        Ouvrir
      </button>
      <button
        type="button"
        className="bulk-toast__close"
        aria-label="Fermer la notification"
        onClick={() => bulk.dismissToast()}
      >
        <span className="material-symbols-rounded" aria-hidden="true">
          close
        </span>
      </button>
      <div className="bulk-toast__countdown" aria-hidden="true" />
    </div>
  );
}
